module.exports = __webpack_public_path__ + "static/media/icon_ANAF.157993f2.jpg";